module.exports = __webpack_public_path__ + "static/rave-reviewz-logo.c20ad4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/rave-reviewz-logo.png
// module id = 863
// module chunks = 114276838955818